import { breakpoints, Text } from "iparque-components";
import styled, { css } from "styled-components";
import {
  AppearFromBottomProps,
  getAnimationConfig,
} from "theme/staggeredAnimations";

const appearFromBottom = css<AppearFromBottomProps>`
  opacity: 1;

  @media (min-width: ${breakpoints.md}) {
    opacity: 0;

    ${({ isSectionVisible, index }) =>
      isSectionVisible ? getAnimationConfig(index, { columns: 3 }) : ""};
  }
`;

export const Container = styled.div`
  ${appearFromBottom};
  max-width: 300px;

  > div:first-of-type {
    max-width: 300px;
    transform: translate(-10%, -10%);

    @media (max-width: ${breakpoints.sm}) {
      width: 70%;
    }
  }
`;

export const TextContainer = styled.div`
  float: left;
  cursor: pointer;
`;

export const UnderlinedText = styled(Text)`
  text-decoration: underline;

  :hover {
    opacity: 0.7;
  }
`;
